.page {
  min-height: calc(100vh - 68px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: var(--bg);
}

.card {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 52px 36px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-sm);
}

.icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: var(--green-lt);
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--green);
}

.title {
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -.02em;
  margin-bottom: 8px;
}

.sub {
  font-size: 15.5px;
  color: var(--muted);
  max-width: 380px;
  margin: 0 auto 28px;
  line-height: 1.65;
}

.whatNext {
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 18px 20px;
  text-align: left;
  max-width: 400px;
  margin: 0 auto 28px;
}

.sectionLabel {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--muted2);
  text-transform: uppercase;
  letter-spacing: .08em;
  margin-bottom: 12px;
}

.item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: var(--ink2);
  margin-bottom: 11px;
}
.item:last-child { margin-bottom: 0; }

.itemIcon {
  color: var(--green);
  flex-shrink: 0;
  margin-top: 1px;
}

.actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
